module.exports = __webpack_public_path__ + "img/logo.594d4992.png";